import { defineQuery } from 'next-sanity'
import { paddingFields, imageFields } from '../atoms'

export const copyBlockFields = `
  _id,
  _type,
  title,
  "padding": {
    ${paddingFields}
  },
  backgroundColor,
  showColumnTitle,
  titleAligned,
  body[],
  titleImage {
    ${imageFields},
    size
  }
`

export const COPY_BLOCK_QUERY = defineQuery(/* groq */ `
  *[_type == "copy-block"][0]{
    ${copyBlockFields}
  }
`)
